import { gql } from 'src/__generated__/gql';

const ALL_TOURNAMENT_CATEGORIES = gql(`
  query allTournamentCategories($filter: ListCategorySettingInput) {
    allTournamentCategories(filter: $filter)
  }
`);

export default ALL_TOURNAMENT_CATEGORIES;
